import { render, staticRenderFns } from "./monitorBillList.vue?vue&type=template&id=22883ca3&"
import script from "./monitorBillList.vue?vue&type=script&lang=js&"
export * from "./monitorBillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports